import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { SUBMITTED_STATUSES } from 'register-partners-js/constants/registration-statuses';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class RegistrationRoute extends Route {
  mainLayout = MainLayout;

  @service router;

  redirect() {
    let registration = this.modelFor('registration');
    if (SUBMITTED_STATUSES.includes(registration.status)) {
      return this.router.replaceWith('registrations');
    }
  }

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');
    return { registration, organization };
  }
}
